import React from "react";
import ReactHtmlParser from 'react-html-parser';

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import './css/editor.css';
import translateString from "../utils/Locales";

let t = translateString;

export default class NotificaWidget extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            option: this.option,
        }
    }

    componentDidMount(){
        console.error(this.props.lezione);
    }

    render (){
        
        return ( 

        <div key={Math.random()}  style={{display: this.props.show == true ? 'block' : 'none'}}> 
            <div style={container} onClick={() => { this.setState({ visible: false }); this.props.onClose(); }}>
            <div style={mainClass} onClick={(e) => e.stopPropagation()}>
                
            <div style={closeBtn} onClick={() => {
                this.setState({visible: false});
                this.props.onClose();
            }}>
                <img alt="" src={ require('../images/close_icon.png')} style={{ width: 30, height: 30, cursor: 'pointer' }} />
            </div>

                <div style={{paddingLeft: '5px'}}>
                <div style={windowTitle}>{t('dettagli_notifica')}</div>
                </div>

                <p style={{ marginLeft: 13, marginTop: 20, width: '90%', fontSize: 18, fontColor: 'darkgrey' }}>{this.props.notifica.title}</p>
                <div style={{ marginLeft: 13, width: '90%', marginTop: -5 }}>
                    { ReactHtmlParser(this.props.notifica.bodyFull.replace('\\n', ''))}
                </div>
                <br/>
            </div>
            </div>
        </div>
        )
    }
}

const windowTitle = {
    color: 'darkgrey', 
    fontSize: 30, 
    fontWeight: 'bold', 
    fontFamily: 'Teko', 
    textAlign:'left', 
    marginLeft: 5, 
    marginBottom: 10,
}

const closeBtn = {
    position: 'absolute', 
    cursor: 'pointer',
    right: 10, 
    top: 10, 
    padding: 10, 
    zIndex: 999,
}

const container = {
    position: 'fixed', 
    display: 'block', 
    top: 0,
    left: 0, 
    bottom: 0, 
    right: 0,
    minWidth: '100%', 
    minHeight: '100%', 
    backgroundColor: '#3C3C3C4D',
    overflowY: 'scroll',
    overflowX: 'hidden',
};

const mainClass = {
    paddingBottom: 10, 
    position: 'absolute',
    left: 'calc((100% - 400px)/2',
    top: '200px',
    right: '35%',
    minWidth: '400px',
    width: '400px',
    background: 'white',
    padding: '20px',
    zIndex: 999,
    boxShadow: '0px 2px 10px darkgrey', 
    borderRadius: '10px',
}